// Add your custom JS here.
(function($){
    $(document).ready(function (){
        
        
        $(window).scroll(function(){
            $('nav').toggleClass('scrolled', $(this).scrollTop() > 50);
        });
        
        $("body").scrollspy({
            offset: 100,
            target: "#main-nav"
        })

        $( ".btn-custom" ).click(function() {$("#toggle-button").toggleClass("fa-chevron-down fa-chevron-up")})


    });
})(window.jQuery);